import { Controller } from '@hotwired/stimulus'

// FAQs de la portada de cuentas (ENH-RNK-7023): el <details> nativo abre y cierra de golpe, así
// que el alto se anima a mano (0,35 s) y la respuesta entra con un fundido. Un clic a medias
// invierte desde el alto en que esté. Mientras se cierra, el <details> sigue abierto y lleva
// `data-faq="cerrar"`, que gira ya el icono. Sin JavaScript o con «reducir movimiento», el
// <details> abre como siempre.
const CURVA = { duration: 350, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }

export default class extends Controller {
  connect () {
    this.animaciones = new WeakMap()
  }

  alternar (evento) {
    const cabecera = evento.target.closest('.rnk-DsFaq_Cabecera')
    if (!cabecera || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    evento.preventDefault()
    const item = cabecera.parentElement
    const abrir = item.dataset.faq ? item.dataset.faq === 'cerrar' : !item.open
    const desde = item.getBoundingClientRect().height
    this.animaciones.get(item)?.cancel()
    item.open = false
    const cerrado = item.getBoundingClientRect().height
    item.open = true
    const abierto = item.getBoundingClientRect().height
    item.dataset.faq = abrir ? 'abrir' : 'cerrar'
    item.style.overflow = 'hidden'

    const respuesta = item.querySelector('.rnk-DsFaq_Respuesta')
    if (respuesta && abrir) respuesta.animate({ opacity: [0, 1] }, CURVA)
    const animacion = item.animate({ height: [`${desde}px`, `${abrir ? abierto : cerrado}px`] }, CURVA)
    this.animaciones.set(item, animacion)
    animacion.onfinish = () => {
      item.open = abrir
      item.style.overflow = ''
      delete item.dataset.faq
      this.animaciones.delete(item)
    }
  }
}
